// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a3bbd273","496":"6b8368cb","498":"edef4349","513":"d30eab93"}[chunkId] + ".chunk.js";
};